import { createTheming } from '@callstack/react-theme-provider';
const { ThemeProvider, useTheme } = createTheming({
  backgroundColor: '#ffca29',
  IconColor: '#ffca29',
  mainColor: 'balck',
  companyColor: '',
});
export { ThemeProvider, useTheme };
